module.exports = __webpack_public_path__ + "img/pending.abe084e4.svg";